<h2 class="step-title">{{ title }}</h2>

<h3 class="slider-value">{{ sliderDisplay }}</h3>
<p class="step-subtitle">
  {{ loanAmount }}
</p>

<div class="slider-container">
  <input class="slider is-fullwidth is-circle is-large" type="range" (input)="slide($event); countVisitorAction();"
   [(value)]="sliderValue" min="0" [max]="sliderValues.length - 1" [sliderValue]="sliderValue" sliderProgress>
   <p class="help is-danger" *ngIf = "control.errors" >{{control.errors.message}}</p>
  <app-slider-label left="0%" right="100%" disableAddPlus="true"></app-slider-label>
</div>

<button class="button continue is-large has-shadow-small" (click)="submit(sliderValue)">
  Continue
<i class="fas fa-chevron-right"></i>
</button>
